import React, { FC, useState, useEffect } from "react";
import {
  repositoryAccessById,
  patchAccessRepositoryById,
} from "../../../redux/slices/RepositoryAccess";
import { useAppDispatch, useAppSelector } from "../../../redux/store/store";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import "./ListAdminAccessRepository.css";
import { refreshToken2 } from '../../../refreshToken2';
import { useMsal } from '@azure/msal-react';
import { SerializedError } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import {
  getHttpErrorCategory,
  handleSwalMessage,
  isHttpCodeSuccess
} from "../../../Helpers/Http.commons";


interface IAdminAccessRepository {
  id: string;
  repositoryId?: any;
  repositoryName?: any;
  userId: string;
  userEmail: string;
  status: string;
  accessType: string;
  error: {
    status: number;
    detail: string;
    title: string;
  };
}

interface RequestResponse {
  statusCode: number;
  response: Object;
  error: any;
}

const ListAdminAccessRepository = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const requestId = String(id);
  const navigate = useNavigate();
  const { instance } = useMsal();

  const result: IAdminAccessRepository = useAppSelector(
    (state: { RepositoryAccess: { result: any } }) =>
      state.RepositoryAccess.result
  );
  const error: IAdminAccessRepository = useAppSelector(
    (state: { RepositoryAccess: { error: any } }) =>
      state.RepositoryAccess.error
  );

  useEffect(() => {
    setLoading(true);
    loadContent();
    setLoading(false);
  }, [requestId]);
  
  const loadContent = async () => {
    await refreshToken2(instance);
    console.log("refreshToken2 finished");
    if(requestId) await dispatch(repositoryAccessById(requestId));
    console.log("fetch repositoryAccessById finished");
  };

  const handleDocumentRequest = (action: string) => {
    setButtonLoading(true);

    dispatch(
      patchAccessRepositoryById({
        id: requestId,
        data: { 'status': action },
        repositoryName: result.repositoryName,
      })
    ).then((responseData) => {
      if (patchAccessRepositoryById.fulfilled.match(responseData)) {
        const { statusCode, response, error } = responseData.payload;
        console.log('responseData', responseData);
        const httpStatus = getHttpErrorCategory(statusCode);
        const swalData: any = handleSwalMessage(responseData.payload, status);
        Swal.fire(swalData);

        if (isHttpCodeSuccess(statusCode)) {
          console.log('============ REDIRECT LOG: [ListAdminAccessRepository] - Navigate to /my-repositories');
          navigate("/my-repositories");
          
        } 
      } else if (patchAccessRepositoryById.rejected.match(responseData)) {
        Swal.fire({
          icon: "error",
          title: "Error de Conexión",
          text: "Revise su conexión a internet y vuelva a intentar",
        });
      }
      setLoading(false);
    });
    setButtonLoading(false);
  };


  return loading ? (
    <Spinner />
  ) : (
    <div className="container-access-request">
      <div className="pds-card pds-productCard-access-request">
        <div
          className="pds-card-section pds-card-bg-primary-blue-2 pds-card-div-1"
          tabIndex={0}
        >
          <h3 className="pds-card-title pds-typography-truncate pds-title">
            Solicitud de Acceso a Repositorio
          </h3>
          <p className="pds-typography-body-14 pds-subtitle">
            (*) Para continuar con la solicitud favor seleccionar aprobar o
            rechazar
          </p>
        </div>
        <div className="pds-card-section pds-section-productcard">
          <dl className="pds-gridTable pds-product-card-gridtable" tabIndex={0}>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Nombre de Repositorio
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{result.repositoryName}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Correo de Solicitante
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{result.userEmail}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Tipo de acceso
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{result.accessType}</span>
              </dd>
            </div>
            <div className="row">
              <dt className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                Estado
              </dt>
              <dd className="pds-gridTable-data col-xs-12 col-sm-6 pds-typography-eyebrow-2">
                <span className="">{result.status}</span>
              </dd>
            </div>
          </dl>
        </div>
        <div className="buttons-access-request">
          {result.status === "rejected" || result.status === "finished" ? (
            <Link to="/my-repositories">
              <button className="pds-button pds-button-primary">
                <i data-feather="corner-up-left" aria-hidden="true"></i> Volver
              </button>
            </Link>
          ) : (
            <>
              <button
                className="pds-button pds-button-primary"
                disabled={
                  result.status === "rejected" ||
                  result.status === "finished" ||
                  loading
                }
                onClick={() => handleDocumentRequest("finished")}
              >
                <i data-feather="check-circle" aria-hidden="true"></i>{" "}
                {loading ? <Spinner /> : "Aprobar"}
              </button>
              &nbsp;
              <button
                className="pds-button pds-button-primary"
                disabled={
                  result.status === "rejected" ||
                  result.status === "finished" ||
                  loading
                }
                onClick={() => handleDocumentRequest("rejected")}
              >
                <i data-feather="trash-2" aria-hidden="true"></i>{" "}
                {loading ? <Spinner /> : "Rechazar"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListAdminAccessRepository;
